import React from "react";
import c from "classnames";

import css from "./block.module.scss";

const WindowBlock = ({ src, style, children, className }) => {
  return <div className={c(css["wb-wrapper"], className)}>{children}</div>;
};

export default WindowBlock;
